export enum DownloadOptionType {
  EXCEL,
  EXCEL_SELECTED,
  PDF_LIST,
  PDF_CARDS,
}
